// frontend/src/pages/builder/legacyRoutes.js
// Phase 3 step 12 (decision D5): the previous builder is gone. Its URLs keep
// working: /charts/new opens the new builder, and /charts/new?id=ID opens
// that chart in it (a chart that still needs updating is explained there,
// with a link to its page, where the update is). Pure and unit-tested.

/** Where a /charts/new URL (its search string) now goes. */
export function newBuilderPath(search) {
  const id = Number(new URLSearchParams(search || '').get('id'));
  return Number.isInteger(id) && id > 0 ? `/charts/build?chart=${id}` : '/charts/build';
}